document.addEventListener('DOMContentLoaded', function () {

  // Function to open the first accordion item
  function openFirstAccordion() {

    // Find the first accordion trigger button
    const firstTrigger = document.querySelector('[data-accordion-trigger]');
    if (!firstTrigger) return;

    // Open it if it's not open yet
    if (firstTrigger.getAttribute('aria-expanded') === 'false') {
      firstTrigger.click();
    }

    // Smooth scroll to the accordion (optional)
    firstTrigger.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }


  // 1) When clicking any link with href="#open-accordion"
  document.addEventListener('click', function (e) {

    // Check if the clicked element is a link
    const link = e.target.closest('a');

    if (!link) return;

    // Only react if href is exactly "#open-accordion"
    if (link.getAttribute('href') === '#open-accordion') {
      e.preventDefault();
      openFirstAccordion();
      
      // Update URL without jump
      history.replaceState(null, '', '#open-accordion');
    }
  });


  // 2) If the page loads with #open-accordion (direct link)
  if (window.location.hash === '#open-accordion') {
    openFirstAccordion();
  }

});


document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".sec-2-per-row__accordion-content-inner-aq09ubenlcjfxmdhlyaigenblock5f7b3d3afddzf p");
  const target = document.querySelector(".ai-comparison-table-atnlroe0zamxgzgrzcaigenblock9073abbwqhjpb");

  if (trigger && target) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  }
});

